import type { Theme } from '@mui/material';
import React from 'react';
const autocomplete = (): Theme['components'] => ({
  MuiAutocomplete: {
    defaultProps: {
      size: 'small',
      popupIcon: <i className='material-symbols-arrow-drop-down-rounded' />,
      clearIcon: <i className='material-symbols-close-rounded w-[20px] h-[20px]' />,
      slotProps: {
        chip: {
          size: 'small',
          deleteIcon: <i className='material-symbols-close-rounded' />
        }
      }
    },
    styleOverrides: {
      root: ({
        ownerState
      }) => ({
        '& .MuiButtonBase-root.Mui-disabled i, & .MuiButtonBase-root.Mui-disabled svg': {
          color: 'var(--mui-palette-action-disabled)'
        },
        // Autocomplete pads its own input, so a leading icon needs the 4px icon-to-text gap restated here.
        '& .MuiOutlinedInput-root:has(> .MuiInputAdornment-positionStart) .MuiAutocomplete-input': {
          paddingLeft: '4px'
        },
        '& .MuiOutlinedInput-root': {
          padding: ownerState.multiple === true ? '4px !important' : undefined,
          overflow: ownerState.multiple === true ? 'hidden' : undefined,
          height: ownerState.size === 'small' ? '32px' : ownerState.size === 'large' ? '58px' : '48px',
          gap: ownerState.multiple === true ? '4px' : undefined
        },
        ...(ownerState.multiple === true && {
          position: 'relative',
          '& .Mui-focused.MuiOutlinedInput-root': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 'auto',
            minHeight: '32px',
            zIndex: 1,
            backgroundColor: 'var(--mui-palette-background-paper)'
          }
        })
      }),
      input: {
        '& + .MuiAutocomplete-endAdornment': {
          right: '4px',
          '& i, & svg': {
            fontSize: '1.5rem',
            color: 'var(--mui-palette-text-primary)'
          },
          '& .MuiAutocomplete-clearIndicator': {
            padding: 2
          }
        },
        '&.MuiInputBase-inputSizeSmall + .MuiAutocomplete-endAdornment': {
          '& i, & svg': {
            fontSize: '1.375rem'
          }
        }
      },
      tag: ({
        theme,
        ownerState
      }) => ({
        ...(ownerState.multiple === true && {
          margin: 0,
          borderRadius: '4px',
          '& .MuiChip-label': {
            ...theme.typography.subtitle2,
            maxWidth: '14ch',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          },
          '& .MuiChip-deleteIcon': {
            fontSize: '1rem',
            color: 'var(--mui-palette-primary-main)'
          }
        })
      }),
      paper: {
        boxShadow: 'var(--mui-customShadows-lg)',
        marginBlockStart: '0.125rem'
      },
      listbox: ({
        theme
      }) => ({
        '& .MuiAutocomplete-option': {
          paddingBlock: theme.spacing(2),
          overflow: 'hidden',
          '&[aria-selected="true"]': {
            backgroundColor: 'unset',
            color: 'var(--mui-palette-primary-main)'
          },
          '&.Mui-focused, &.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-primary-dark)',
            color: 'var(--mui-palette-primary-main)'
          }
        }
      })
    }
  }
});
export { autocomplete };